import { ActionReducerMap, MetaReducer } from '@ngrx/store';
import { logoutMetaReducer } from '../meta-reducers/logout.meta-reducers';

export interface AppState {}

export const reducers: ActionReducerMap<AppState> = {};

export const metaReducers: MetaReducer<AppState>[] = [logoutMetaReducer];
